export default {"src":"https://dap-fvkt0crba-dap-rewrite.vercel.app/_next/static/media/notification_icon.762ae837.svg","height":27,"width":28};